module.exports = __webpack_public_path__ + "static/media/vangibenedetta_resume.4292f21e.pdf";